<template>
  <table width="100%">
    <tr>
      <td align="center" height="120px" :style="{ backgroundColor: logo.color }">
        <img :src="logo.url" :width="width" :alt="logo.url" />
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'ExternalHeader',
  props: {
    logo: {
      type: Object,
      required: true,
    },
    width: {
      type: String,
      required: false,
      default: '200',
    },
  },
}
</script>
